import { createRouter, createWebHistory } from 'vue-router';

import Index from '@/pages/Index';

import Dashboard from '@/pages/dashboard/Layout';
import DashboardIndex from '@/pages/dashboard/children/Index';
import DashboardUser from '@/pages/dashboard/children/User';
import DashboardTorrent from '@/pages/dashboard/children/Torrent';
import DashboardWechatProxy from '@/pages/dashboard/children/WechatProxy';
import DashboardSecurity from '@/pages/dashboard/children/Security';

import Login from '@/pages/user/Login';
import Regist from '@/pages/user/Regist';

const user = {
  path: 'user',
  component: Index,
  children: [
    {
      path: 'login',
      component: Login,
      meta: {
        title: '用户登录'
      }
    }, {
      path: 'regist',
      component: Regist,
      meta: {
        title: '用户注册'
      }
    }
  ]
};

const dashboard = {
  path: 'dashboard',
  component: Dashboard,
  redirect: '/dashboard/index',
  children: [
    {
      path: 'index',
      component: DashboardIndex,
      meta: {
        title: '首页'
      }
    }, {
      path: 'wechatProxy',
      component: DashboardWechatProxy,
      meta: {
        title: '微信代理'
      }
    }, {
      path: 'user',
      component: DashboardUser,
      meta: {
        title: '用户管理'
      }
    }, {
      path: 'torrent',
      component: DashboardTorrent,
      meta: {
        title: '种子列表'
      }
    }, {
      path: 'security',
      component: DashboardSecurity,
      meta: {
        title: '安全设置'
      }
    }
  ]
};

const routes = [{
  path: '/',
  component: Index,
  children: [
    user,
    dashboard
  ]
}];

export default createRouter({
  history: createWebHistory(),
  routes
});
